import type { ActivationClaims, ActivationState } from './ActivationClaims';

export class LicensePolicyService {
  /**
   * Vérifie la validité calendaire et l'empreinte poste (hors signature JWT).
   * Le client d'origine du poste n'est pas opposable : une clé valide dont le
   * quota de postes est disponible active n'importe quel poste, l'arbitrage du
   * quota revenant à licensing-api.
   */
  evaluateLocalPolicy(
    claims: ActivationClaims,
    deviceFingerprint: string,
    currentTenantId: string,
    currentSalariesCount: number,
    nowSec: number = Math.floor(Date.now() / 1000),
  ): ActivationState {
    if (claims.device_fingerprint !== deviceFingerprint) {
      return { valid: false, claims, errorCode: 'DEVICE_MISMATCH', isReadOnly: true };
    }
    if (currentTenantId && claims.tenant_id !== currentTenantId) {
      return { valid: false, claims, errorCode: 'TENANT_MISMATCH', isReadOnly: true };
    }
    if (claims.nbf > nowSec) {
      return { valid: false, claims, errorCode: 'NOT_YET_VALID', isReadOnly: true };
    }
    if (claims.exp <= nowSec) {
      return { valid: true, claims, errorCode: 'EXPIRED', isReadOnly: true };
    }
    if (claims.max_salaries > 0 && currentSalariesCount > claims.max_salaries) {
      return { valid: false, claims, errorCode: 'TOO_MANY_SALARIES', isReadOnly: false };
    }
    return { valid: true, claims, isReadOnly: false };
  }
}
